import { render, staticRenderFns } from "./TableRatesLosAndOccupancyContent.vue?vue&type=template&id=0bceea24&scoped=true&"
import script from "./TableRatesLosAndOccupancyContent.vue?vue&type=script&lang=js&"
export * from "./TableRatesLosAndOccupancyContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bceea24",
  null
  
)

export default component.exports